<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Contatti</li>
            </ul>
            <h2>Contattaci</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div id="map">
    <iframe src="https://maps.google.com/maps?q=europelife%20largo%204%20agosto%201943,%204%20eboli%20Italia&t=k&z=19&ie=UTF8&iwloc=&output=embed"></iframe>
</div>

<div class="contact-area ptb-100">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Chi siamo</span>
                    <h2>Il Migliore Ente di Formazione Accreditato e Certificato</h2>
                    <p>
                        La Europe L.I.F.E. S.c.r.l., azienda nata nel 1989 ed iscritta all’albo delle società cooperative dal 2005, trasformatosi in impresa sociale nel 2012, ha sede ad Eboli (SA) in via Largo 4 agosto 1943 n. 4 e opera nei settori dei servizi alle imprese, della formazione, della comunicazione e organizzazione eventi e manifestazioni.
                    </p>
                    <p>
                        La cooperativa, nei vari ambiti operativi, ha maturato nel corso degli anni una notevole esperienza garantendo ai clienti sempre massima professionalità ed efficienza nel raggiungimento degli obiettivi fissati.
                    </p>
                    <p>
                        La Europe L.I.F.E., centro elaborazione dati a partire dal 2001, offre servizi alle imprese dalla consulenza contabile ed amministrativa alla formazione: l’attività di formazione costituisce l’hub tra le aziende e la forza lavoro, perché rappresenta uno strumento preferenziale per la crescita personale e professionale, permette alle aziende e ai professionisti di mantenere le loro risorse umane costantemente aggiornate ed al passo coi tempi e, in molti casi, anticiparli per posizionarsi sul mercato prima dei propri competitor.
                    </p>
                    <p>
                        Negli ultimi anni ha ampliato la propria gamma di servizi anche nel settore della comunicazione specializzandosi in eventi e comunicazione itinerante nel contesto del Marketing territoriale di enti pubblici ed imprese del territorio del Mezzogiorno.
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">dalla formazione alla professione</span>
                    <h2>Cosa abbiamo di Speciale?</h2>
                    <p>
                        La società ha condotto attività volte al supporto della promozione e della valorizzazione del territorio e incoraggiato l’adozione e la diffusione delle Tecnologie di Informazione e Comunicazione (TIC). Nel settore della comunicazione ha ideato, progettato e realizzato con successo, campagne di comunicazione e di promozioni a eventi promossi sia, da Amministrazioni Pubbliche quali Regione e Provincia, che da Aziende e Associazioni di Categoria.
                    </p>
                    <p>
                        Nell’arco degli anni si è specializzata nella formazione professionale accreditandosi già nel 2004 come Ente di Formazione presso la Regione Campania.
                    </p>
                    <p>
                        L’Europe L.I.F.E. è partner del PIF (Progetti Integrati di Filiera) “Filiera Ortofrutticola Piana del Sele” approvato con il Decreto Dirigenziale n. 98 dell’ 8 aprile 2010, primo classificato tra i progetti relativi alla filiera ortofrutticola.
                    </p>
                    <p>
                        In particolare la Cooperativa si è occupata della progettazione esecutiva dei piani formativi (n. 32 Corsi di Formazione) a valere sulla Misura 111 “Azioni nel campo della formazione professionale e dell’informazione” del PSR Campania 2007-2013.
                    </p>
                    <p>
                        L’Europe L.I.F.E. è infine partner del “Polo Tecnico-Professionale per il Turismo Integrato e lo Sviluppo Agro Ambientale nella Provincia di Salerno” approvato con Decreto Dirigenziale n. 3 del 06 novembre 2013.
                    </p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Informazioni</span>
                    <h2>Mettiti in contatto</h2>
                    <p>Ci piace ascoltare i lettori. Apprezziamo davvero che tu abbia dedicato del tempo per metterci in contatto.</p>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class='bx bx-map'></i>
                            </div>
                            <h3>Dove siamo</h3>
                            <p>largo 4 agosto 1943, 4<br>84025 Eboli (SA)</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-phone-call'></i>
                            </div>
                            <h3>Contatti</h3>
                            <p>Mobile: <a href="tel:+390828cap evboli
                                369026">(+39) 0828-369026</a></p>
                            <p>e-mail: <a href="mailto:info@europelife.it">info@europelife.it</a></p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-time-five'></i>
                            </div>
                            <h3>Siamo disponibili</h3>
                            <p>Lunedì - Venerdì: 09:00 - 18:00</p>
                            <p>Sabato: 09:00 - 13:00</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-form" *ngFor="let Image of bgImage;" style="background-image: url({{Image.img}});">
                    <h2>Come possiamo aiutarti?</h2>
                    <p>L'indirizzo email non verrà pubblicato. i campi richiesti sono contrassegnati dal simbolo*</p>
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name" placeholder="Nome e Cognome">
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">Nome e Cognome richiesto.</div>
                                        <div *ngIf="name.errors.minlength">Numero minimo {{ name.errors.minlength.requiredLength }} di caratteri.</div>
                                        <div *ngIf="name.errors.maxlength">Numero massimo di 50 caratteri.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email" placeholder="la tua e-mail">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number" placeholder="cellulare">
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">un contatto telefonico è obbligatorio</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="5" class="form-control" placeholder="scrivi il tuo messaggio..."></textarea>
                                    <div class="alert alert-danger" *ngIf="message.touched && !name.valid">il messaggio è obbligatorio</div>
                                </div>
                            </div>
                            <h2 class="mt-3">Quale corso sei interessato?</h2>
                            <p>seleziona il corso interessato alla quale vuoi avere informazioni*</p>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <select name="sceltaCorso" ngModel id="sceltaCorso" #sceltaCorso="ngModel" style="display: block;
                                    width: 100%;
                                    border: none;
                                    color: var(--blackColor);
                                    background-color: #F3F6F9;
                                    height: 50px;
                                    padding-left: 15px;
                                    border-radius: 5px;
                                    font-size: var(--fontSize);
                                    font-weight: 600">
                                        <option value="{{elencoCorsiRow['corso']['titolo']}}" *ngFor="let elencoCorsiRow of elencoCorsi">{{elencoCorsiRow['corso']['titolo']}}</option>
                                      </select>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 mt-3">
                                <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid">Invia Richiesta<span></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
